import { add, isBefore, isSameDay, isToday, parse } from "date-fns";

import { TTimeOption } from "@components/TimePicker/types";
import Router from "@lib/router/Router";
import { DATE } from "@utils/constants";

import { TPickupTimeFrame } from "../types";

// cutoff time - minimal time courier will take to go to the customer (minutes)
// minimalInterval - minimal possible time between from and to times for pickup (hours)

const getAvailablePickupTimesFrom = (
  timeFrames: TPickupTimeFrame[],
  selectedPickupDateStr?: string
): TTimeOption[] | undefined => {
  if (!selectedPickupDateStr) {
    return undefined;
  }
  const selectedPickupDate = parse(selectedPickupDateStr, DATE.DATE_TEMPLATE, new Date());
  const selectedTimeFrame = timeFrames.find(({ date }) => isSameDay(date, selectedPickupDate));
  if (!selectedTimeFrame?.timeFrameFrom?.length) {
    return undefined;
  }

  const isTodaysPickup = isToday(selectedPickupDate);
  const isLithuaniaPage = Router.defaultLocale === "lt";

  const availableTimesFrom = selectedTimeFrame.timeFrameFrom.reduce<TTimeOption[]>((acc, time) => {
    const timeDate = parse(time, "HH:mm", new Date());
    const cutoff = (isLithuaniaPage && time === "15:00") ? 0 : (selectedTimeFrame.cutoff || 0);

    if (!isTodaysPickup || !isBefore(timeDate, add(new Date(), { minutes: cutoff }))) {
      acc.push({ time });
    }
    return acc;
  }, []);

  return availableTimesFrom;
};

const getAvailablePickupTimesTo = (
  timeFrames: TPickupTimeFrame[],
  selectedPickupDateStr?: string,
  selectedPickupTimeFrom?: string
): TTimeOption[] | undefined => {
  if (!selectedPickupDateStr) {
    return undefined;
  }
  const selectedPickupDate = parse(selectedPickupDateStr, DATE.DATE_TEMPLATE, new Date());
  const selectedTimeFrame = timeFrames.find(({ date }) => isSameDay(date, selectedPickupDate));
  if (!selectedTimeFrame?.timeFrameTo?.length) {
    return undefined;
  }

  const isTodaysPickup = isToday(selectedPickupDate);
  const timeFromDate = selectedPickupTimeFrom ? parse(selectedPickupTimeFrom, "HH:mm", new Date()) : undefined;
  const isLithuaniaPage = Router.defaultLocale === "lt";

  const availableTimesTo = selectedTimeFrame.timeFrameTo.reduce<TTimeOption[]>((acc, time) => {
    const timeDate = parse(time, "HH:mm", new Date());
    const cutoff = (isLithuaniaPage && selectedPickupTimeFrom === "15:00") ? 0 : (selectedTimeFrame.cutoff || 0);

    if (
      (!isTodaysPickup || !isBefore(timeDate, add(new Date(), { minutes: cutoff }))) &&
      (!timeFromDate ||
        !isBefore(timeDate, add(timeFromDate, { minutes: Math.ceil((selectedTimeFrame.minimalInterval || 0) * 60) })))
    ) {
      acc.push({ time });
    }
    return acc;
  }, []);

  return availableTimesTo;
};

export { getAvailablePickupTimesFrom, getAvailablePickupTimesTo };
